import { API_BASE_URL, itemsOnPage } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { buildDefaultHeaders } from "./helper";
import {
  GET_METHOD_OFFICE_CYCLE,
  GET_METHOD_OFFICE_ROLES,
  GET_METHOD_OFFICE_ACCESS,
  SET_METHOD_OFFICE_LOADING,
  GET_METHOD_OFFICE_ACCESS_FILTERED_PERSONNEL,
  GET_METHOD_OFFICE_ACCESS_PERSONNEL,
  METHOD_OFFICE_TABLE_CLEAN,
  GET_METHOD_OFFICE_FILES,
  GET_METHOD_OFFICE_FOLDER,
  GET_METHOD_OFFICE_SUBFOLDER,
  GET_METHOD_OFFICE_FILE,
} from "./types";


export const getMethodOfficeCycle = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/mathodicalroom/cycle`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {

      const cycle = await response.json();

      dispatch({ type: GET_METHOD_OFFICE_CYCLE, payload: cycle });

    }
  }
};

export const getMethodOfficeFile = (data) => async (dispatch, getState) => {
  const urlParams = new URLSearchParams(data).toString();
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const response = await fetch(`${API_BASE_URL}/mathodicalroom/files/get?${urlParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.blob()
      const objectURL = URL.createObjectURL(result);
      dispatch({ type: GET_METHOD_OFFICE_FILE, payload: objectURL });
      return objectURL;
    } else dispatch({ type: GET_METHOD_OFFICE_FILE, payload: null });
  }
  return null;
};

export const getMethodOfficeRoles = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/permission_groups/mathodicalroom`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {

      const roles = await response.json();

      dispatch({ type: GET_METHOD_OFFICE_ROLES, payload: roles });

    }
  }
};
export const getMethodOfficeAccess = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/mathodicalroom/access`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {

      const access = await response.json();

      dispatch({ type: GET_METHOD_OFFICE_ACCESS, payload: access });

    }
  }
};

export const getMethodOfficeAccessFilteredPersonnel = (params) => async (dispatch, getState) => {
  const { role, cycle } = params
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/people/mathodicalroom?pmid=${role}&did=${cycle}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: GET_METHOD_OFFICE_ACCESS_FILTERED_PERSONNEL, payload });
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};

export const methodOfficeTableClean = () => ({
  type: `${METHOD_OFFICE_TABLE_CLEAN}`
});

export const getMethodOfficeAccessPersonnel = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/people/mathodicalroom`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: GET_METHOD_OFFICE_ACCESS_PERSONNEL, payload });
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};


export const updateMethodOfficeAccess = (access) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    try {
      const response = await fetch(`${API_BASE_URL}/people/mathodicalroom`, {
        method: "PUT",
        body: JSON.stringify({ access }),
        ...buildDefaultHeaders(getState),
      });
      if (response.ok) {
        await dispatch(getMethodOfficeAccessPersonnel());
      } else {
        throw new Error('Ошибка обновления доступа');
      }
    } finally {
      dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
    }
  } else {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
  }
};

export const getMethodOfficeFiles = (mr_parent) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/mathodicalroom/files/${mr_parent}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: GET_METHOD_OFFICE_FILES, payload });
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};

export const getMethodOfficeFolders = (mr_parent) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(mr_parent !== 0 ?
      `${API_BASE_URL}/mathodicalroom/folder/${mr_parent}` :
      `${API_BASE_URL}/mathodicalroom/folder`
      , {
        method: "GET",
        ...buildDefaultHeaders(getState),
      });
    if (response.ok) {
      const payload = await response.json();
      mr_parent === 0 ?
        dispatch({ type: GET_METHOD_OFFICE_FOLDER, payload }) :
        dispatch({ type: GET_METHOD_OFFICE_SUBFOLDER, payload });
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};


export const createFile = (file, mrid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    try {
      const responseInfo = await fetch(`${API_BASE_URL}/mathodicalroom/files/${mrid}`, {
        method: "POST",
        body: JSON.stringify({ mr_name: file.name }),
        ...buildDefaultHeaders(getState),
      });

      if (!responseInfo.ok) {
        throw new Error('Ошибка создания записи файла');
      }

      const payload = await responseInfo.json();

      const fd = new FormData()
      fd.append('file', file)
      const response = await fetch(`${API_BASE_URL}/mathodicalroom/files/save/${payload.mrid}`, {
        method: "POST",
        body: fd,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`nnz:${getState().auth.token}`)}`,
        },
      });

      if (response.ok) {
        await dispatch(getMethodOfficeFiles(mrid));
      } else {
        throw new Error('Ошибка загрузки файла');
      }
    } catch (error) {
      console.error('Error creating file:', error);
      throw error;
    } finally {
      dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
    }
  } else {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
  }
};

export const createFolder = (mrid, params) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    try {
      const response = await fetch(`${API_BASE_URL}/mathodicalroom/folder/${mrid || 0}`, {
        method: "POST",
        body: JSON.stringify(params),

        ...buildDefaultHeaders(getState),
      });

      if (response.ok) {
        await dispatch(getMethodOfficeFolders(0));
      } else {
        throw new Error('Ошибка создания папки');
      }
    } catch (error) {
      console.error('Error creating folder:', error);
      throw error;
    } finally {
      dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
    }
  } else {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
  }
};

export const updateFolder = (mrid, mr_parent, params) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    try {
      const response = await fetch(`${API_BASE_URL}/mathodicalroom/folder/${mr_parent}/${mrid}`, {
        method: "PUT",
        body: JSON.stringify(params),
        ...buildDefaultHeaders(getState),
      });

      if (response.ok) {
        await dispatch(getMethodOfficeFolders(0));
      } else {
        throw new Error('Ошибка обновления папки');
      }
    } catch (error) {
      console.error('Error updating folder:', error);
      throw error;
    } finally {
      dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
    }
  } else {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
  }
};

export const deleteLowFolder = (mrid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/mathodicalroom/folder/${mrid}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      await dispatch(getMethodOfficeFolders(0));
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};
export const deleteFiles = (mrid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/mathodicalroom/files/${mrid}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      await dispatch(getMethodOfficeFolders(0));
    }
  }
  dispatch({ type: SET_METHOD_OFFICE_LOADING, payload: false });
};